import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { PayeeApi } from '../shared/sdk/services';
import { LoopBackConfig } from '../shared/sdk/lb.config';
import { Payee, AccessToken } from '../shared/sdk/models';

import { Router, ActivatedRoute, Params} from '@angular/router';
import { GlobalEventsManager } from '../events-manager.component'
import { HttpClient,HttpHeaders } from  "@angular/common/http";


@Component({
  selector: 'resetPassword',
  templateUrl: 'resetPassword.component.html',
  styleUrls: ['login.component.css']
})

export class ResetPasswordComponent implements OnInit {

  name: string;
  userId: number;
  access_token: string;

  password:string;
  confirmPassword:string;
  passwordValid:boolean;

  
  @Output() popUp: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private userApi: PayeeApi,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private http:HttpClient,
    private eventsManager: GlobalEventsManager
    ) { 
  }
  ngOnInit() { 
    if(this.userApi.isAuthenticated()){
      this.router.navigate(['/dashboard']);
    }
   this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.userId = params['userId'];
      this.access_token = params['access_token'];
      console.log("userId");
      console.log(this.userId);

      console.log("access_token");
      console.log(this.access_token);
    });
  }

  goToServices() {
    this.router.navigate(['/form']);
  }

  validatePassword(password,confirmPassword) {
    if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$@$!%*#?&]{8,}$/.test(password)) {
      this.eventsManager.showPopUp("Password must contain at least 8 alphanumeric characters AND at least 1 uppercase letter.");
    } else {
        this.resetPassword(password);
    }
  }

  resetPassword(password) {
    var body = {
        newPassword: password
      };
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    // this.userApi.setPassword(password).subscribe(
    //       data => {
    //         this.eventsManager.showPopUp("You have successfully reset your password.");
    //         this.router.navigate(['/login']);
    //       }, 
    //       error => {
    //         this.eventsManager.showPopUp("Reset token expired. Please request for password reset again.");
    //         console.log(JSON.stringify(error));
    //       }
    //     );

    var _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/users/reset-password";
    this.http
      .post(_url+'?access_token='+this.access_token,
        body, {
          headers: headers
        })
        .subscribe(
          data => {
            this.eventsManager.showPopUp("You have successfully reset your password.");
            this.router.navigate(['/login']);
          }, 
          error => {
            this.eventsManager.showPopUp("Reset token expired. Please request for password reset again.");
            console.log(error);
          }
        );
  }

}